import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'customer-title-content',
  standalone: true,
  imports: [
    CommonModule,
  ],
  template: `
  <div class="fx-col fx-gap-3">
    <div
      *ngIf="title"
      class="tw-text-base tw-font-medium title">
      {{ title }}
    </div>
    <p
      *ngIf="content"
      class="content text-normal-wrap tw-text-sm tw-font-normal">
      {{ content }}
    </p>
  </div>
  `,
  styleUrls: ['./title-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleContentComponent {
  @Input() title?: string;
  @Input() content?: string;
}
